import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-crear-servicio',
  templateUrl: './crear-servicio.component.html',
  styleUrls: ['./crear-servicio.component.css']
})
export class CrearServicioComponent implements OnInit {

  code:string = `    this.subscription = this._defaultService.getCountries().subscribe(countries => {
    this.paises = countries;
  }, err => {
    this.navCtrl.push(ErrorPage, {message: "datosPaises", error: err, page: this.navCtrl.getActive().name});
  });`;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Consejos/crear-servicio/crear-servicio.component.ts